"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformValues = transformValues;

var _setWith = _interopRequireDefault(require("lodash/setWith"));

var _set = _interopRequireDefault(require("lodash/set"));

function transformValues(values) {
  return unflatten(values);
}

function unflatten(obj, opts) {
  var separator = '.';
  var objectMode = false;

  if (typeof opts === 'string') {
    separator = opts;
  } else if (typeof opts === 'boolean') {
    objectMode = opts;
  } else if (opts) {
    separator = opts.separator || separator;
    objectMode = opts.objectMode;
  }

  var dotSep = separator === '.';
  var re = new RegExp(separator, 'g');
  var newObj = {};

  for (var path in obj) {
    if (objectMode) {
      (0, _setWith["default"])(newObj, dotSep ? path : path.replace(re, '.'), obj[path], Object);
    } else {
      (0, _set["default"])(newObj, dotSep ? path : path.replace(re, '.'), obj[path]);
    }
  }

  return newObj;
}